import { render, staticRenderFns } from "./FormSkipReview.vue?vue&type=template&id=2777ecd9&scoped=true"
import script from "./FormSkipReview.vue?vue&type=script&lang=js"
export * from "./FormSkipReview.vue?vue&type=script&lang=js"
import style0 from "./FormSkipReview.vue?vue&type=style&index=0&id=2777ecd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2777ecd9",
  null
  
)

export default component.exports